module.exports = __webpack_public_path__ + "static/img/hsteel-thumb.3e6d571.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/hsteel-thumb.jpg
// module id = 4tdX
// module chunks = 0